import { AdvancedFilterButton } from '@/components/common/AdvancedFilter';
import { PageHeader } from '@/components/layout/PageHeader';
import { RBAC_PERMISSIONS } from '@/constants/permissions';

interface UserListHeaderProps {
  title: string;
  searchText: string;
  onSearchChange: (value: string) => void;
  filterOpen: boolean;
  onFilterToggle: () => void;
  activeFilterCount: number;
  onCreateClick?: (() => void) | undefined;
}

export function UserListHeader({
  title,
  searchText,
  onSearchChange,
  filterOpen,
  onFilterToggle,
  activeFilterCount,
  onCreateClick,
}: UserListHeaderProps) {
  return (
    <PageHeader
      title={title}
      search={{
        value: searchText,
        onChange: onSearchChange,
        placeholder: 'Name, Username, ID, Mobile',
      }}
      actions={
        <AdvancedFilterButton
          isOpen={filterOpen}
          activeCount={activeFilterCount}
          onClick={onFilterToggle}
        />
      }
      createAction={
        onCreateClick
          ? {
              label: 'Add User',
              mobileLabel: 'Add User',
              onClick: onCreateClick,
              requires: RBAC_PERMISSIONS.USER_CREATE,
            }
          : undefined
      }
    />
  );
}
